export default {
  isUserLoggedIn: () => !!localStorage.sellerID
}
